import React, { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import GraclAuthorizer from './components/GraclAuthorizer';

const GraclListAuditLogRecordsPage = lazy(() => import('./pages/auditLog/ListAuditLogRecords'));
const GraclListChangeRequestsPage = lazy(() => import('./pages/changeRequest/ListChangeRequests'));
const GraclListScheduledChangesPage = lazy(() => import('./pages/scheduledChanges/ListScheduledChanges'));

const routes: RouteObject[] = [
  {
    element: <GraclAuthorizer />,
    children: [
      {
        path: '/portal/gracl',
        element: <Navigate to='/' replace />
      },
      {
        path: '/portal/gracl/audit-log',
        element: <GraclListAuditLogRecordsPage />
      },
      {
        path: '/portal/gracl/change-requests',
        element: <GraclListChangeRequestsPage />
      },
      {
        path: '/portal/gracl/scheduled-changes',
        element: <GraclListScheduledChangesPage />
      }
    ]
  }
];

export default routes;
